import { Run } from '../icons/Run/Run';
import { Walk } from '../icons/Walk/Walk';
import { Cycle } from '../icons/Cycle/Cycle';
import { Swim } from '../icons/Swim/Swim';

export const addActivityIcons = (activities) => {
  activities.forEach((activity) => {
    if (activity.activity === 'WALKING') {
      activity.activity = <Walk />;
    }

    if (activity.activity === 'RUNNING') {
      activity.activity = <Run />;
    }

    if (activity.activity === 'CYCLING') {
      activity.activity = <Cycle />;
    }

    if (activity.activity === 'SWIMMING') {
      activity.activity = <Swim />;
    }

    if (activity.activity === 'OTHER') {
      activity.activity = 'OTHER';
    }
  });

  return activities;
};
